import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { LoginComponent } from '../login/login.component';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss']
})
export class ResetpasswordComponent implements OnInit {
  submitReset:boolean = false;
  showreset:boolean = true;
  disabledResend:boolean = false;
  seconds:any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private authService: AuthService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.seconds==0
  }

  emailreg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/


  resetForm = this.fb.group({
    email: new FormControl('', [Validators.required, Validators.pattern(this.emailreg)]),
  });


  get c(){
    return this.resetForm.controls
  }

  onClickReset(){
    this.submitReset = true;
    let req_body = {
      "email":this.resetForm.value.email,
    }

    this.authService.forgetPassword(req_body)
    .subscribe((res: any) => {
      if(res.status ==200){
        this.getTimeRemaining(60000);
        this.toastr.success(res.message);
        this.showreset = !this.showreset;
      }
    },(err)=>{
      console.log(err,"error");
          this.toastr.error(err.error.error.message);
        this.showreset = true;
    })


    // try{

    //   this.submitReset = true;
    //   let req_body = {
    //     "email":this.resetForm.value.email,
    //     // "userType": this.data.userType.user
    // }
    //   this.authService.forgetPassword(req_body)
    //   .subscribe((res: any) => {
    //       this.toastr.success(res.message);
    //       this.showreset = !this.showreset;

    //   },(error: any) => {
    //     this.toastr.error(error.error.message);
    //     this.showreset = true;
    //   })

    // }
    // catch(e){}
  }

  backToSignIn(){
    this.seconds = 0;
    try{
      const dialogRef = this.dialog.open(LoginComponent, {
        data: {
          userType: {
            titleOne: 'Add Your',
            titleTwo: 'Organization',
            text: "Be the MVP! Set your team up with game day meals from local restaurants with ease. Just sign up, add your events and select from a variety of restaurants. Share your team codes and you're set for the season.",
            user: 2,
            imgPath: '../../../assets/image/landing-page-2.png'
          }
        },
      });
    }
    catch(e){}
  }


  getTimeRemaining(miliseconds:any){
    let x = setInterval(()=>{
      // if(this.seconds==0){
      //   console.log('00' + ':' + this.seconds + ' Seconds');
      //   this.disabledResend = false;
      //   clearInterval(x);
      // }
      miliseconds = miliseconds - 1000;
      this.seconds = Math.floor((miliseconds % (1000 * 60)) / 1000);
      if(this.seconds<10){
        this.seconds = `0${this.seconds}`;
      }
      if(this.seconds==0){
        console.log('00' + ':' + this.seconds + ' Seconds');
        this.disabledResend = false;
        clearInterval(x);
      }else{
        this.disabledResend = true;
        if(this.seconds){
          (<HTMLInputElement>document.getElementById('time')).innerHTML = '00' + ':' + this.seconds;
        }
      }
        
    },1000)
}

  resendClick(){
    if(this.disabledResend){
      return
    }
    let req_body = {
      "email":this.resetForm.value.email,
    }

    this.authService.forgetPassword(req_body)
    .subscribe((res: any) => {
      if(res.status ==200){
        this.seconds=60;
        this.getTimeRemaining(60000);
        this.toastr.success(res.message);
      }
    },(err)=>{
      console.log(err,"error");
          this.toastr.error(err.error.error.message);
    })
  }

  onClickBack(){
    this.seconds = 0;
  }


}
